
const geneticEvolve = () => {
    return {
        type: "GENETIC_EVOLVE"
    }
}

export default geneticEvolve;


// WEBPACK FOOTER //
// ./src/store/geneticActions/geneticEvolve.js